import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import { resolveWeatherIconCode } from '../../../../util/weatherCodeMapper';

// Small async-loaded weather icon, mirroring the loading pattern used by
// TimelineItem (dynamic import of the bundled PNG asset).
export default function WeatherIcon({ weatherCode, period, size = 28 }) {
  const [image, setImage] = useState(null);

  useEffect(() => {
    let active = true;
    if (weatherCode) {
      const iconCode = resolveWeatherIconCode(weatherCode, period);
      import(`../../../../assets/weathericons/${iconCode}_g.png`)
        .then((img) => {
          if (active) setImage(img.default);
        })
        .catch(() => {});
    }
    return () => {
      active = false;
    };
  }, [weatherCode, period]);

  if (!image) return <Box w={`${size}px`} h={`${size}px`} />;
  return (
    <Box
      as="img"
      src={image}
      alt=""
      w={`${size}px`}
      h={`${size}px`}
      objectFit="contain"
    />
  );
}
